import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateModules } from "../../actions";
import AboutUs from "@identitybuilding/idb-react-about-us";
import {
  OsnTextarea,
  Button,
  OsnInputText,
} from "@identitybuilding/idb-react-ui-elements";
import axios from "axios";

const AboutUsEdit = (props) => {
  const dispatch = useDispatch();

  let modules = useSelector((state) => state.AdminReducer.modules);
  let data = useSelector((state) => state.AdminReducer.data);
  let colors = useSelector((state) => state.AdminReducer.colors);

  let [aboutUsDesciption, setAboutUsDesciption] = useState(
    data.options.about_us.text
  );
  let [aboutUsTitle, setAboutUsTitle] = useState(data.options.about_us.title);
  let entityCopy = Object.assign({}, data);
  let modulcesCopy = [...modules];

  const handler = (action, keyword) => {
    if (action === "template") {
      entityCopy.options.about_us.template = keyword;
      adminChange(keyword, action);
    }
    if (action === "title") {
      entityCopy.options.about_us.title = keyword;
      adminChange(keyword, action);
    }
    if (action === "text") {
      entityCopy.options.about_us.text = keyword;
      adminChange(keyword, action);
    }
    if (action === "theme") {
      entityCopy.options.about_us.theme = keyword;
      adminChange(keyword, action);
    }

    modulcesCopy[props.index].module = (
      <AboutUs
        template={entityCopy.options.about_us.template}
        title={entityCopy.options.about_us.title}
        theme={entityCopy.options.about_us.theme}
        description={entityCopy.options.about_us.text}
        image={"https://o-sn.be/onepagedemo/about.jpg"}
        colors={colors}
      />
    );

    dispatch(updateModules(modulcesCopy));
  };

  const adminChange = (props, action) => {
    axios
      .put(
        `https://onepage-78a00-default-rtdb.europe-west1.firebasedatabase.app/data/data/options/about_us.json`,
        {
          [action]: props,
          ...entityCopy.options.about_us,
        }
      )
      .then(async (resp) => {
      });
  };

  return (
    <div className="testBlock">
      <div className="testTitle">About us</div>
      <div>
        <span>Title:</span>
        <OsnInputText
          onChange={(e) => setAboutUsTitle(e.target.value)}
          value={aboutUsTitle}
          placeholder={aboutUsTitle}
        />
        <Button
          bgColor={["cn"]}
          size="S"
          text="Change title"
          txtColor="white"
          type="main"
          onClick={() => handler("title", aboutUsTitle)}
        />
      </div>
      <div>
        <span>Description:</span>
        <OsnTextarea
          onChange={(e) => setAboutUsDesciption(e.target.value)}
          value={aboutUsDesciption}
          placeholder={aboutUsDesciption}
        />
        <Button
          bgColor={["cn"]}
          size="S"
          text="Change description"
          txtColor="white"
          type="main"
          onClick={() => handler("text", aboutUsDesciption)}
        />
      </div>
      <div>
        <span>Template:</span>
        <ul>
          <li onClick={() => handler("template", 1)}>1</li>
          <li onClick={() => handler("template", 2)}>2</li>
          <li onClick={() => handler("template", 3)}>3</li>
          <li onClick={() => handler("template", 4)}>4</li>
        </ul>
      </div>
      <div>
        <span>Theme:</span>
        <ul>
          <li onClick={() => handler("theme", "dark")}>dark</li>
          <li onClick={() => handler("theme", "main")}>main</li>
          <li onClick={() => handler("theme", "sub")}>sub</li>
          <li onClick={() => handler("theme", "light")}>light</li>
        </ul>
      </div>
    </div>
  );
};
export default AboutUsEdit;
